import React from 'react';
import DrawingOptions from 'components/quote_builder_widget/DrawingOptions';

const QuoteBuilderForm = ({ theme, id, setId, drawing, unitOption = 'both', widgetIdentifier }) => {
  const DrawingMaterialChooser = theme.DrawingMaterialChooser;

  return (
    <div>
      <DrawingOptions
        theme={theme}
        id={id}
        setId={setId}
        drawing={drawing}
        unitOption={unitOption}
      />
      {widgetIdentifier && DrawingMaterialChooser && (
        <DrawingMaterialChooser widgetIdentifier={widgetIdentifier} drawingId={id} />
      )}
    </div>
  );
};

export default QuoteBuilderForm;
